import React from 'react';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';
import Popup from '../../index';
import Button from '../../../button';
import Icon from '../../../icon';
import {confirmFreeLicensesPopup} from '../../../../../actions/popupActions';
import {putUpdateCollaborators} from '../../../../../actions/sharingDetailsActions';
import {postFreeLicense} from '../../../../../actions/usersListActions';

function ConfirmFreeLicensesPopup (props) {

	const {
		confirmFreeLicensesPopup,
		setConfirmFreeLicensesPopup,
		postFreeLicense
	} = props;
	const { t } = useTranslation();

	const proceed = () => {
		postFreeLicense(confirmFreeLicensesPopup);
		setConfirmFreeLicensesPopup(null);
	};

	return (
		<Popup className="p-4" onClose={() => setConfirmFreeLicensesPopup(null)}>
			<h2 className="text-danger"><Icon name="user-times"/> {t("Unlicensepopupheading")}</h2>
			<p>{t("UnlicensepopupMsg1")}</p>
			<div className="text-right">
	            <Button onClick={proceed} className="btn-primary">{t("Unlicensepopupbutton")}</Button>
			</div>
		</Popup>
	)
}

const mapStateToProps = (state) => {
	return {
		confirmFreeLicensesPopup: state.popupReducer.confirmFreeLicensesPopup,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setConfirmFreeLicensesPopup : (object) => {
			dispatch(confirmFreeLicensesPopup(object))
		},
		putUpdateCollaborators : (object, fromUsersLicensesList, freeLicense) => {
			dispatch(putUpdateCollaborators(object, fromUsersLicensesList, freeLicense))
		},
		postFreeLicense: (userId) => {
			dispatch(postFreeLicense(userId))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmFreeLicensesPopup);